import { atom } from "recoil";

export const gamesMetaTagsStore = atom({
	key: "gamesMetaTagsStore",
	default: {
		show: false,
		filters: {
			sorting: {
				column: "created_at",
				order: "desc",
			},
			search: "",
			page: 1,
			limit: 10,
		},
		data: [],
		totalPages: 0,
		loaded: true,
		details: false,
	},
});

export const gamesTagsStore = atom({
	key: "gamesTagsStore",
	default: {
		filters: {
			sorting: {
				column: "created_at",
				order: "desc",
			},
			search: "",
			page: 1,
			limit: 5,
		},
		data: [],
		loaded: true,
		totalPages: 0,
	},
});
